import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Avatar, Grid, Box } from "@material-ui/core";
import Typed from "react-typed";
import avatar from "../avatar.png";

const Header = () => {
  const classes = useStyles();
  return (
    <Box className={classes.typedContainer}>
      <Grid container justify="center">
        <Avatar className={classes.avatar} src={avatar} alt="Icon of ME" />
      </Grid>
      <Typography className={classes.title} variant="h4">
        <Typed strings={["Robert Garza Portfolio"]} typeSpeed={100} />
      </Typography>
      <br />
      <Typography className={classes.subtitle} variant="h4">
        <Typed
          strings={["HTML/CSS", "JAVASCRIPT", "SQL", "NOSQL", "NODE", "REACT"]}
          typeSpeed={60}
          loop
        />
      </Typography>
    </Box>
  );
};

// CSS
const useStyles = makeStyles((theme) => ({
  avatar: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    margin: theme.spacing(1),
  },
  title: {
    color: "red",
  },
  subtitle: {
    color: "tan",
    marginBottom: "3rem",
  },
  typedContainer: {
    position: "absolute",
    top: "30%",
    // left: "50%",
    // transform: "translate(-50%, - 50%)",
    width: "100vw",
    textAlign: "center",
    zIndex: 1,
  },
}));

export default Header;
